import React from 'react';
import { NetworkStatusIndicator } from '@bilderit/offline-link';
import { cn } from '@/utils/utils';

export const OfflineIndicator: React.FC = () => (
  <NetworkStatusIndicator indicator={IndicatorInner} />
);

const IndicatorInner: React.FC<{ networkStatus: boolean }> = ({
  networkStatus,
}) => {
  const [showBanner, setShowBanner] = React.useState(false);
  const timer = React.useRef<NodeJS.Timeout | undefined>(undefined);
  React.useEffect(() => {
    if (!networkStatus) {
      timer.current && clearTimeout(timer.current);
      setShowBanner(true);
    } else {
      timer.current && clearTimeout(timer.current);
      timer.current = setTimeout(() => setShowBanner(false), 4000);
    }
    return () => timer.current && clearTimeout(timer.current);
  }, [networkStatus]);

  if (!showBanner) return null;
  return (
    <div
      className={cn(
        networkStatus ? 'bg-success' : 'bg-warning',
        'w-full text-center font-medium'
      )}
    >
      {!networkStatus
        ? 'Estás trabajando sin conexión'
        : 'Se recuperó la conexión, sincronizando...'}
    </div>
  );
};
